var _circle, _circle2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconGrade(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 128,
    r: 116,
    stroke: "black",
    strokeWidth: 8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 128,
    r: 96,
    stroke: "black",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M182.5 128C185.538 128 188 130.462 188 133.5V133.5C188 136.538 185.538 139 182.5 139H172.5C169.462 139 167 136.538 167 133.5V133.5C167 130.462 169.462 128 172.5 128H182.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7 164.154C83.8234 166.623 81.487 168.273 78.8668 168.273V168.273C74.563 168.273 71.5728 163.989 73.0562 159.949L106.041 70.1177C107.391 66.4427 110.89 64 114.805 64V64C118.72 64 122.219 66.4427 123.568 70.1177L156.553 159.949C158.037 163.989 155.046 168.273 150.743 168.273V168.273C148.122 168.273 145.786 166.623 144.909 164.154L115.348 80.8801C115.267 80.65 115.049 80.4963 114.805 80.4963V80.4963C114.561 80.4963 114.343 80.65 114.261 80.8801L84.7 164.154ZM88.1255 133.142C88.1255 130.049 90.633 127.541 93.7261 127.541H135.883C138.976 127.541 141.484 130.049 141.484 133.142V133.142C141.484 136.235 138.976 138.742 135.883 138.742H93.7261C90.633 138.742 88.1255 136.235 88.1255 133.142V133.142Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGrade);
export default __webpack_public_path__ + "static/media/icon-grade.53ab9c2c02c0583cb9947b74e5c8af84.svg";
export { ForwardRef as ReactComponent };